export class Admin {
    ehiGroupId: number;
    groupName: string;
    month: number;
    year: number;
    locked: boolean;
    lastUpdated: Date;
    performedBy: string;
}
